import { FeedbackModalProps, OwnOption } from "@cabonline/ui-web";
import { ActionMeta, MultiValue } from "react-select";
import type { UserStatusFilterValue } from '../utils/user-status-filter';

export interface StoredUserFilters {
  selectedAgreement: MultiValue<OwnOption>;
  selectedRole: MultiValue<OwnOption>;
  selectedStatuses: readonly UserStatusFilterValue[];
}

export interface SelectOption {
  value: string;
  label: string;
}

export type MultiSelectOnChange = (
  newValue: MultiValue<OwnOption>,
  actionMeta?: ActionMeta<OwnOption>
) => void;

export type FeedbackType = 'success' | 'error';

export interface FeedbackData extends FeedbackModalProps {
  type: FeedbackType;
}

export interface FeedbackContextType {
  show: (data: FeedbackData) => void;
  hide: () => void;
}

export interface FeedbackAnnouncementProps {
  data: FeedbackData | undefined;
}

export interface FeedbackModalWrapperProps {
  data: FeedbackData | undefined;
  isAnyModalOpen: boolean;
  deviceType: string;
  closeButtonLabel: string;
}

export interface SessionTimeoutContextType {
  resetIdleTimer: () => void;
}

// Session Timeout Constants
export const WARNING_DURATION_MS = 120_000; // 2 minutes
export const MAX_EXTENSIONS = 10;
export const EXTENSION_COUNT_KEY = 'session_extension_count';
